module.exports = __webpack_public_path__ + "img/public/SiteIcons/fileIconRed.svg?0b327d08";